import history from '../constants/history';

const LoginContainer = (auth) => {
  !auth.isAuthenticated() ? auth.login() : history.push('/home');
  return null;
};

export default LoginContainer;
